import { initMainNav } from "./main-nav";
import { initNavPreviewer } from "./previewer";

export function initNav() {

    initMainNav();

    initNavPreviewer();

}
